/**
 * AI生成プロフィール入力ステップ
 */
import { GenerationStatus } from "features/generation/types";
import { GenderStep } from "./GenderStep";
import { BirthdayStep } from "./BirthdayStep";
import { FavoritesStep } from "./FavoritesStep";
import { IconPreviewStep } from "./IconPreviewStep";
import { PlayerProfileSubStepBar } from "../../components";
import { CreatePlayerState, PlayerProfileSubStep, PlayerFavoritesSubStep } from "../../types";

interface PlayerProfileAIStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
  currentSubStep: PlayerProfileSubStep;
  generationStatus: GenerationStatus;
  generationProgress: number;
  generatedImage: string | null;
  partialImage: string | null;
  favoritesSubStep: PlayerFavoritesSubStep;
  onSubStepNext: () => void;
  onSubStepClick: (
    targetSubStep: PlayerProfileSubStep,
    targetFavoritesSubStep?: PlayerFavoritesSubStep,
  ) => void;
  // 追加プロンプト関連
  additionalPrompt?: string;
  onAdditionalPromptChange?: (prompt: string) => void;
  onRegenerate?: () => void;
  // サブステップバー用
  completedStepIds?: string[];
  isGenerating?: boolean;
}

export const PlayerProfileAIStep = ({
  state,
  updateState,
  currentSubStep,
  generationStatus,
  generationProgress,
  generatedImage,
  partialImage,
  favoritesSubStep,
  onSubStepClick,
  additionalPrompt,
  onAdditionalPromptChange,
  onRegenerate,
  completedStepIds,
  isGenerating,
}: PlayerProfileAIStepProps) => {
  const renderContent = () => {
    switch (currentSubStep) {
      case PlayerProfileSubStep.GENDER:
        return <GenderStep state={state} updateState={updateState} />;
      case PlayerProfileSubStep.BIRTHDAY:
        return <BirthdayStep state={state} updateState={updateState} />;
      case PlayerProfileSubStep.FAVORITES:
        return (
          <FavoritesStep
            state={state}
            updateState={updateState}
            favoritesSubStep={favoritesSubStep}
          />
        );
      case PlayerProfileSubStep.ICON_PREVIEW:
        return (
          <IconPreviewStep
            status={generationStatus}
            progress={generationProgress}
            generatedImage={generatedImage}
            partialImage={partialImage}
            additionalPrompt={additionalPrompt}
            onAdditionalPromptChange={onAdditionalPromptChange}
            onRegenerate={onRegenerate}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex-row-el w-full h-full">
      {/* サブステップ進捗バー（左側） */}
      <PlayerProfileSubStepBar
        currentSubStep={currentSubStep}
        favoritesSubStep={favoritesSubStep}
        onStepClick={onSubStepClick}
        completedStepIds={completedStepIds}
        isGenerating={isGenerating}
      />

      {/* コンテンツ（右側・中央揃え） */}
      <div className="flex-col-el flex-center flex-1 min-h-0">{renderContent()}</div>
    </div>
  );
};
